// extracted by mini-css-extract-plugin
export default {"reveal":"Reveal_reveal__kAXBn","revealVisible":"Reveal_revealVisible__Z-0lh"};